import {FC, ReactNode} from 'react';
import styled from 'styled-components';

const Container = styled.div`
`;

type TProps = {
    rowGapClass?: string;
    children: ReactNode;
}

const ListCollection: FC<TProps> = ({rowGapClass, children}) => {
    return (
        <Container className={`cr-flex cr-flex-col ${rowGapClass ?? 'cr-gap-xxl'}`}>
            {children}
        </Container>
    );
}

export default ListCollection;
